/*
 * Men's gallery + men-context links for recommendation cards (complementary / related).
 *
 * These cards are loaded via AJAX from /recommendations/products, where the
 * `collection` object is not available, so neither the men's image nor the
 * collection-scoped product URL can be produced in Liquid. Each dual product
 * card outputs its men's image URL(s) as data attributes; this script, when the
 * page is a men's-collection context (/collections/men/products/...), swaps the
 * image and rewrites the card's product links to /collections/men/products/...
 * so the men's context carries to the next product page.
 *
 * It only touches cards that have a men's gallery (data-men-primary) inside
 * <product-recommendations>, so it never interferes with the server-side men's
 * logic already applied on collection and product pages, and never points a
 * link at a collection the product isn't in.
 */
(function () {
  if (window.__menGalleryCardsInit) return;
  window.__menGalleryCardsInit = true;

  function inMenContext() {
    // Matches /collections/men/ with or without a locale prefix (e.g. /lt/collections/men/...).
    // Does not match /collections/women/.
    return /\/collections\/men(\/|$)/.test(window.location.pathname);
  }

  if (!inMenContext()) return;

  // The men collection path prefix from the current URL, preserving any locale prefix.
  var menMatch = window.location.pathname.match(/^(.*\/collections\/men)(?:\/|$)/);
  var collectionBase = menMatch ? menMatch[1] : null;

  function swapImage(img, url) {
    if (!img || !url) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  function rewriteLink(a) {
    if (!a || a.dataset.menLinked) return;
    var href = a.getAttribute('href');
    if (!href) return;
    // Already scoped to a collection — leave it as is.
    if (/\/collections\/[^/]+\/products\//.test(href)) {
      a.dataset.menLinked = '1';
      return;
    }
    var match = href.match(/\/products\/([^/?#]+)(.*)?$/);
    if (!match) return;
    a.setAttribute('href', collectionBase + '/products/' + match[1] + (match[2] || ''));
    a.dataset.menLinked = '1';
  }

  function processCard(card) {
    if (!card.dataset.menSwapped) {
      var primaryUrl = card.getAttribute('data-men-primary');
      if (primaryUrl) {
        var primary =
          card.querySelector('.product-card__image--primary') ||
          card.querySelector('.horizontal-product-card__image');
        swapImage(primary, primaryUrl);

        var secondaryUrl = card.getAttribute('data-men-secondary');
        if (secondaryUrl) {
          swapImage(card.querySelector('.product-card__image--secondary'), secondaryUrl);
        }
      }
      card.dataset.menSwapped = '1';
    }

    if (collectionBase) {
      card.querySelectorAll('a[href*="/products/"]').forEach(rewriteLink);
    }
  }

  function processBlock(block) {
    block.querySelectorAll('[data-men-primary]').forEach(processCard);
  }

  function init() {
    var blocks = document.querySelectorAll('product-recommendations');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      processBlock(block);
      new MutationObserver(function () {
        processBlock(block);
      }).observe(block, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();